module.exports = __webpack_public_path__ + "static/img/163_TO8_1900.42cb2dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/163_TO8_1900.jpg
// module id = 4lIc
// module chunks = 0